import { ManageUserFormValue } from './manage-user.interfaces';

export function createManageUserFormValue(): ManageUserFormValue {
  return {
    username: '',
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    mobile_no: '',
    role_id: null,
    assign_role_menus: false,
  };
}
